import { Component, OnInit } from '@angular/core';
import { PlmService } from 'src/app/shared/services/plm.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-plm-pavement-progress',
  templateUrl: './plm-pavement-progress.component.html',
  styleUrls: ['../plm-shared.css'],
})
export class PlmPavementProgressComponent implements OnInit {
  projects: any[] = [];
  projectId: number | null = null;
  locations: any[] = [];
  catalog: any[] = [];
  workItems: any[] = [];
  furnitureKind = 'toll-plaza';
  furniture: any[] = [];
  locForm: any = { location_kind: 'lrs_span', location_name: '', from_measure_m: '', to_measure_m: '', lrs_route_id: '' };
  workForm: any = { work_location_id: '', layer_id: '', side: 'full', planned_qty: '', uom: 'cum' };
  furnForm: any = { code: '', name: '', from_measure_m: '', to_measure_m: '' };
  kinds = [
    { id: 'toll-plaza', label: 'Toll plaza' },
    { id: 'bus-bay', label: 'Bus bay' },
    { id: 'truck-bay', label: 'Truck bay' },
    { id: 'wim', label: 'WIM' },
    { id: 'parking', label: 'Breakdown parking' },
    { id: 'channel', label: 'Channel' },
  ];

  constructor(private plm: PlmService, private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.api.getProjectCommonAll({ page: 1, limit: 200 }).subscribe({
      next: (res: any) => {
        this.projects = res?.data || res?.rows || [];
      },
    });
    this.plm.pavementCatalog().subscribe({
      next: (res: any) => (this.catalog = res.data || []),
    });
  }

  onProject(): void {
    this.reload();
  }

  reload(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listWorkLocations(q).subscribe({ next: (r: any) => (this.locations = r.data || []) });
    this.plm.listPavementWork(q).subscribe({ next: (r: any) => (this.workItems = r.data || []) });
    this.loadFurniture();
  }

  loadFurniture(): void {
    this.plm.listFurniture(this.furnitureKind, { project_id: this.projectId || undefined }).subscribe({
      next: (r: any) => (this.furniture = r.data || []),
    });
  }

  seed(): void {
    if (!this.projectId) return this.toastr.error('Select a project');
    this.plm.seedFromRoadProject(this.projectId).subscribe({
      next: (r: any) => {
        this.toastr.success(`Seeded ${r.seeded || 0} segments`);
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Seed failed'),
    });
  }

  addLocation(): void {
    this.plm
      .createWorkLocation({
        ...this.locForm,
        project_id: this.projectId,
        from_measure_m: this.locForm.from_measure_m || null,
        to_measure_m: this.locForm.to_measure_m || null,
        lrs_route_id: this.locForm.lrs_route_id || null,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Work location added');
          this.reload();
        },
        error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
      });
  }

  addWork(): void {
    this.plm
      .createPavementWork({
        ...this.workForm,
        project_id: this.projectId,
        planned_qty: this.workForm.planned_qty || null,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Layer work item added');
          this.reload();
        },
        error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
      });
  }

  setStatus(row: any, status: string): void {
    const today = new Date().toISOString().slice(0, 10);
    const body: Record<string, unknown> = { status };
    if (status === 'in_progress') body['started_on'] = today;
    if (status === 'completed') body['completed_on'] = today;
    this.plm.updatePavementWork(row.id, body).subscribe({
      next: () => this.reload(),
      error: (e) => this.toastr.error(e?.error?.message || 'Update failed'),
    });
  }

  addFurniture(): void {
    this.plm
      .createFurniture(this.furnitureKind, {
        ...this.furnForm,
        project_id: this.projectId,
      })
      .subscribe({
        next: () => {
          this.toastr.success('Asset added');
          this.loadFurniture();
        },
        error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
      });
  }

  bumpFurniture(row: any, status: string): void {
    const today = new Date().toISOString().slice(0, 10);
    const body: Record<string, unknown> = { construction_status: status };
    if (status === 'in_progress') body['started_on'] = today;
    if (status === 'completed') {
      body['pct_complete'] = 100;
      body['completed_on'] = today;
    }
    this.plm.updateFurniture(this.furnitureKind, row.id, body).subscribe({
      next: () => this.loadFurniture(),
    });
  }

  chainage(row: any): string {
    if (row.from_measure_m == null) return '—';
    const fromKm = (Number(row.from_measure_m) / 1000).toFixed(3);
    const toKm = row.to_measure_m != null ? (Number(row.to_measure_m) / 1000).toFixed(3) : fromKm;
    return `${fromKm}–${toKm} km`;
  }
}
